import { GET_HISTORY, SUBSCRIBE_NEW } from "../ActionTypes"
import { checkDupArrayHistory } from "../FunctionAction/function.project"

const initialState = {
	history: [],
	loading: false,
	LastEvaluatedKey: {}
}
const compare = (a, b) => {
	if (a.created_date > b.created_date) return -1
	if (b.created_date > a.created_date) return 1
	return 0
}
export default (state = initialState, { type, payload }) => {
	const { history } = state
	switch (type) {
		case GET_HISTORY + "_FULFILLED":
			return {
				...state,
				history: checkDupArrayHistory(
					history,
					payload.data.getHistory.data
				).sort(compare),
				LastEvaluatedKey: payload.data.getHistory.next_token,
				loading: false
			}
		case GET_HISTORY + "_PENDING":
			return { ...state, loading: true }
		case GET_HISTORY + "_REJECTED":
			return { ...state, loading: false }
		case SUBSCRIBE_NEW + "_FULFILLED":
			return { ...state, loading: false }
		case SUBSCRIBE_NEW + "_PENDING":
			return { ...state, loading: true }
		case SUBSCRIBE_NEW + "_REJECTED":
			return { ...state, loading: false }
		default:
			return state
	}
}
